import { __extends } from "tslib";
import { DeleteBucketReplicationRequest } from "../models/models_0";
import { deserializeAws_restXmlDeleteBucketReplicationCommand, serializeAws_restXmlDeleteBucketReplicationCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteBucketReplicationCommand = /** @class */ (function (_super) {
    __extends(DeleteBucketReplicationCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteBucketReplicationCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteBucketReplicationCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "DeleteBucketReplicationCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: DeleteBucketReplicationRequest.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteBucketReplicationCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlDeleteBucketReplicationCommand(input, context);
    };
    DeleteBucketReplicationCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlDeleteBucketReplicationCommand(output, context);
    };
    return DeleteBucketReplicationCommand;
}($Command));
export { DeleteBucketReplicationCommand };
//# sourceMappingURL=DeleteBucketReplicationCommand.js.map